import { render } from "./InputTextAreaCustom.vue?vue&type=template&id=7a727942&scoped=true"
import script from "./InputTextAreaCustom.vue?vue&type=script&lang=js"
export * from "./InputTextAreaCustom.vue?vue&type=script&lang=js"

import "./InputTextAreaCustom.vue?vue&type=style&index=0&id=7a727942&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a727942"]])

export default __exports__